
{
  "familyId": "GET-DEEL-KOMMA",
  "questions": [
    {
      "id": "GET-DEEL-KOMMA-001",
      "familyId": "GET-DEEL-KOMMA",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "delen_door_kommagetal",
      "questionType": "multiple_choice",
      "question": "Wat is 6 ÷ 0,5?",
      "options": [
        "12",
        "3",
        "0,12",
        "5,5"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "deel_door_komma_basis",
      "variantIndex": 1,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Strategie: delen door 0,5 = vermenigvuldigen met 2. Stap 1: 6 ÷ 0,5 = 6 × 2 = 12. Of: maak de deler heel: 6 ÷ 0,5 → (6 × 10) ÷ (0,5 × 10) = 60 ÷ 5 = 12.",
        "distractorExplanations": {
          "0": "Goed! 6 ÷ 0,5 = 12. Delen door een half = vermenigvuldigen met 2.",
          "1": "Veelgemaakte fout: vermenigvuldigen in plaats van delen. 6 × 0,5 = 3, maar de vraag is 6 ÷ 0,5 = 12.",
          "2": "Veelgemaakte fout: de komma verkeerd verwerken. 6 ÷ 0,5 = 12, niet 0,12.",
          "3": "Veelgemaakte fout: aftrekken. 6 − 0,5 = 5,5, maar de vraag is delen."
        }
      }
    },
    {
      "id": "GET-DEEL-KOMMA-002",
      "familyId": "GET-DEEL-KOMMA",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "delen_door_kommagetal",
      "questionType": "multiple_choice",
      "question": "Wat is 15 ÷ 0,3?",
      "options": [
        "50",
        "4,5",
        "5",
        "45"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "deel_door_komma_tienden",
      "variantIndex": 2,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Strategie: maak de deler heel door beide × 10. Stap 1: 15 ÷ 0,3 → (15 × 10) ÷ (0,3 × 10) = 150 ÷ 3 = 50.",
        "distractorExplanations": {
          "0": "Goed! 15 ÷ 0,3 = 150 ÷ 3 = 50.",
          "1": "Veelgemaakte fout: vermenigvuldigen. 15 × 0,3 = 4,5, maar de vraag is delen.",
          "2": "Veelgemaakte fout: 15 ÷ 3 = 5. Maar je deelt door 0,3, niet door 3. Maak de deler heel: 150 ÷ 3 = 50.",
          "3": "Veelgemaakte fout: alleen de teller × 10. 150 ÷ 3 = 50, niet 15 ÷ 0,3 = 45."
        }
      }
    },
    {
      "id": "GET-DEEL-KOMMA-003",
      "familyId": "GET-DEEL-KOMMA",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "delen_door_kommagetal",
      "questionType": "multiple_choice",
      "question": "Wat is 4,8 ÷ 0,4?",
      "options": [
        "12",
        "1,2",
        "4,4",
        "0,12"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "deel_door_komma_beide_komma",
      "variantIndex": 3,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Strategie: maak de deler heel. Stap 1: 4,8 ÷ 0,4 → (4,8 × 10) ÷ (0,4 × 10) = 48 ÷ 4 = 12.",
        "distractorExplanations": {
          "0": "Goed! 4,8 ÷ 0,4 = 48 ÷ 4 = 12.",
          "1": "Veelgemaakte fout: de komma niet verwijderen. 4,8 ÷ 4 = 1,2, maar je deelt door 0,4. Maak de deler heel: 48 ÷ 4 = 12.",
          "2": "Veelgemaakte fout: aftrekken. 4,8 − 0,4 = 4,4, maar de vraag is delen.",
          "3": "Veelgemaakte fout: de komma verkeerd plaatsen. 48 ÷ 4 = 12, niet 0,12."
        }
      }
    },
    {
      "id": "GET-DEEL-KOMMA-004",
      "familyId": "GET-DEEL-KOMMA",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "delen_door_kommagetal",
      "questionType": "multiple_choice",
      "question": "Een touw van 9 meter wordt in stukken van 0,75 meter geknipt. Hoeveel stukken krijg je?",
      "options": [
        "12",
        "6,75",
        "9,75",
        "120"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "deel_door_komma_context",
      "variantIndex": 4,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "Strategie: maak de deler heel door × 100. Stap 1: 9 ÷ 0,75 → (9 × 100) ÷ (0,75 × 100) = 900 ÷ 75 = 12.",
        "distractorExplanations": {
          "0": "Goed! 9 ÷ 0,75 = 900 ÷ 75 = 12 stukken.",
          "1": "Veelgemaakte fout: vermenigvuldigen. 9 × 0,75 = 6,75, maar de vraag is delen.",
          "2": "Veelgemaakte fout: optellen. 9 + 0,75 = 9,75, maar de vraag is delen.",
          "3": "Veelgemaakte fout: alleen de teller × 100. 900 ÷ 75 = 12, niet 900 ÷ 7,5 = 120."
        }
      }
    }
  ]
}
